export default [
  {
    title: "Ukulele Music",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=1",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-ukulele.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=1)"
  },
  {
    title: "Creative Minds",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=2",
    audioSrc:
      "https://www.bensound.com//bensound-music/bensound-creativeminds.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=2)"
  },
  {
    title: "A New Beginning",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=3",
    audioSrc:
      "https://www.bensound.com/bensound-music/bensound-anewbeginning.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=3)"
  },
  {
    title: "Little Idea",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=4",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-littleidea.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=4)"
  },
  {
    title: "Happy Rock",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=5",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-happyrock.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=5)"
  },
  {
    title: "Memories",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=6",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-memories.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=6)"
  },
  {
    title: "Acoustic Breeze",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=7",
    audioSrc:
      "https://www.bensound.com/bensound-music/bensound-acousticbreeze.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=7)"
  },
  {
    title: "Adventure",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=8",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-adventure.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=8)"
  },
  {
    title: "Sunny",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=9",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-sunny.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=9)"
  },
  {
    title: "Inspire",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=10",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-inspire.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=10)"
  },
  {
    title: "Clap and Yell",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=11",
    audioSrc:
      "https://www.bensound.com/bensound-music/bensound-clapandyell.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=11)"
  },
  {
    title: "Piano Moment",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=12",
    audioSrc:
      "https://www.bensound.com/bensound-music/bensound-pianomoment.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=12)"
  },
  {
    title: "A Day to Remember",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=13",
    audioSrc:
      "https://www.bensound.com/bensound-music/bensound-adaytoremember.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=13)"
  },

  {
    title: "Dance",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=14",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-dance.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=14)"
  },
  {
    title: "Rumble",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=15",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-rumble.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=15)"
  },
  {
    title: "Love",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=16",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-love.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=16)"
  },
  {
    title: "Scifi",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=17",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-scifi.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=17)"
  },
  {
    title: "November",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=18",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-november.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=18)"
  },
  {
    title: "Small Guitar",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=19",
    audioSrc:
      "https://www.bensound.com/bensound-music/bensound-smallguitar.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=19)"
  },
  {
    title: "Smile",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=20",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-smile.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=20)"
  },
  {
    title: "Downtown",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=21",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-downtown.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=21)"
  },
  {
    title: "Romantic",
    artist: "Benjamin Tissot (also known as Bensound)",
    image: "https://picsum.photos/300?grayscale&random=22",
    audioSrc: "https://www.bensound.com/bensound-music/bensound-romantic.mp3",
    bg: "url(https://picsum.photos/300?grayscale&random=22)"
  }
];
